<template>
  <BreadCrumb :items="breadcrumbItems" />
  <main id="main">
    <div class="contents">
      <div class="mypage_wrap">
        <MyHeader/>
        <div class="mypage_body">
          <MySideBar/>
          <OrderListForm/>
        </div>
      </div>
    </div>
  </main>
  <MainSideBar/>
</template>
<script>
import MainSideBar from "../../layout/navigation/MainSideBar.vue";
import BreadCrumb from "../../layout/navigation/BreadCrumb.vue";
import MyHeader from "../layout/MyHeader.vue";
import MySideBar from "../layout/MySideBar.vue";
import OrderListForm from "@/components/mypage/myShopping/OrderListForm.vue";

export default {
  data() {
    return {
      breadcrumbItems: [
        { href: "/", text: "홈", isHome: true },
        { href: "/mypage/recent-order", text: "마이페이지" },
        { href: "", text: "주문조회" },
      ],
    };
  },
  components: {
    BreadCrumb,
    MainSideBar,
    MyHeader,
    MySideBar,
    OrderListForm
  },
};
</script>
<style lang=""></style>
